<template>
    <v-card
            class="mx-auto"
            max-width="70%"
            outlined
    >
        <!--encabezado-->
        <EncabezadoCard
                :titulo="'Cambiar Password'"
                :sub-titulo="'Una vez que cambie su password, debe volver ingresar al sistema'"
                :icono="'mdi-lock'"
        ></EncabezadoCard>
        <!--fin encabezado-->

        <!-- contenido-->
        <v-card-text>
            <template>
                <v-form
                        @submit.prevent="cambiarPassword" ref="form"
                        v-model="valid"
                        lazy-validation
                        id="frmFormulario"
                        onkeydown="return event.key !== 'Enter';"
                >
                    <v-row>
                        <v-col cols="8" sm="12" md="12">
                            <v-text-field
                                    v-model="item.old_password"
                                    label="Password actual (*)"
                                    :append-icon="valor1 ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="() => (valor1 = !valor1)"
                                    :type="valor1 ? 'password' : 'text'"
                                    required
                                    :counter="20"
                                    maxlength="20"
                                    autocomplete="off"
                                    :rules="[v => !!v || 'Password es requerido',
                                                           v => (v && v.length <= 20 && v.length>=6) || 'El Password debe ser de 6 a 20 caracteres']"/>
                        </v-col>

                        <v-col cols="8" sm="12" md="12">
                            <v-text-field
                                    v-model="item.password"
                                    label="Nuevo Password (*)"
                                    :append-icon="valor2 ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="() => (valor2 = !valor2)"
                                    :type="valor2 ? 'password' : 'text'"
                                    required
                                    :counter="20"
                                    maxlength="20"
                                    autocomplete="off"
                                    :rules="[v => !!v || 'Password es requerido',
                                                           v => (v && v.length <= 20 && v.length>=6) || 'El Password debe ser de 6 a 20 caracteres']"
                            />
                        </v-col>

                        <v-col cols="8" sm="12" md="12">
                            <v-text-field
                                    v-model="item.password_confirmation"
                                    label="Confirmar Password (*)"
                                    :append-icon="valor3 ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="() => (valor3 = !valor3)"
                                    :type="valor3 ? 'password' : 'text'"
                                    required
                                    :counter="20"
                                    maxlength="20"
                                    autocomplete="off"
                                    :rules="[v => !!v || 'Password es requerido',
                                                           v => (v && v.length <= 20 && v.length>=6) || 'El Password debe ser de 6 a 20 caracteres']"
                            />
                        </v-col>


                        <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="12" xs="12" sm="7" align="right">
                                <v-btn type="submit" color="success" class="pl-4 pr-4" :disabled="loading">
                                    <v-progress-circular
                                            v-if="loading"
                                            indeterminate
                                            color="primary"
                                    ></v-progress-circular>
                                    <v-icon left>mdi-content-save</v-icon>
                                    Cambiar password
                                </v-btn>
                            </v-col>
                        </v-row>

                    </v-row>

                </v-form>
            </template>


        </v-card-text>
    </v-card>
</template>

<script>
    import EncabezadoCard from "../components/EncabezadoCard";
    import {mapState} from "vuex";

    export default {
        name: "CambiarPassword",
        components: {EncabezadoCard},
        data: () => ({
            isLoading: false,
            valor1: String,
            valor2: String,
            valor3: String,
            loading: false,
            mensaje: false,
            errores: "",
            valid: false,
            item: {}
        }),
        mounted() {
            this.isLoading = false;
        },
        methods: {
            cambiarPassword() {
                if (!this.$refs.form.validate()) {
                    return;
                }

                this.$funciones.confirm(this.$swal, "Que quires cambiar tu password",).then(result => {
                    if (result.value) {

                        this.loading = true;
                        this.axios({
                            method: 'POST',
                            url: this.url_base + "cambiar_password/" + this.usuario.id,
                            data: this.item
                        }).then(response => {
                            if (response.data.res) {
                                this.loading = false;
                                this.$toastr.success(response.data.message);

                                //logout
                                this.$store.dispatch("destroyToken").then(response => {
                                    this.$router.push({name: "login"});
                                })
                            } else {
                                this.loading = false;
                                this.$toastr.error(response.data.message);
                            }
                        }).catch(e => {
                            this.loading = false;
                            this.$toastr.error(this.$funciones.listaErrores(e.response.data.errors));
                        })
                    }
                });
            }
        },
        computed: {
            ...
                mapState(['url_base', 'usuario'])
        }
    }
</script>

<style scoped>

</style>